/**
 * Приветствие по времени суток — для экрана входа. Границы обычные для
 * русской речи: утро с пяти, день с двенадцати, вечер с восемнадцати,
 * ночь с двадцати трёх.
 */
export function greeting(hour: number): string {
  if (hour >= 5 && hour < 12) return 'Доброе утро';
  if (hour >= 12 && hour < 18) return 'Добрый день';
  if (hour >= 18 && hour < 23) return 'Добрый вечер';
  return 'Доброй ночи';
}
